"use strict";
exports.__esModule = true;
exports.RxpCrime71Experiment = exports.RxpCrime71ExperimentVariantValues = void 0;
var types_1 = require("../types");
// CRIME-71: Onboarding - Customize Schedule - Close payment dates warning modal
// Used in RXP Onboarding flow
var RxpCrime71ExperimentVariantValues;
(function (RxpCrime71ExperimentVariantValues) {
    RxpCrime71ExperimentVariantValues["Treatment"] = "treatment";
})(RxpCrime71ExperimentVariantValues = exports.RxpCrime71ExperimentVariantValues || (exports.RxpCrime71ExperimentVariantValues = {}));
exports.RxpCrime71Experiment = {
    variantID: 'rxp-crime-71',
    controlValue: types_1.CONTROL,
    variantValues: RxpCrime71ExperimentVariantValues
};
